const parseAspectRatio = (str: string) => {
  const [w, h] = str.split(':').map(Number);
  return w / h;
};

export const validateResolution = (
  width: number,
  height: number,
  requiredWidth?: number,
  requiredHeight?: number,
  requiredAspectRatio?: string
) => {
  const matchesWidth = requiredWidth ? width === requiredWidth : true;
  const matchesHeight = requiredHeight ? height === requiredHeight : true;
  const matchesRatio = requiredAspectRatio
    ? Math.abs(width / height - parseAspectRatio(requiredAspectRatio)) < 0.01
    : true;

  return {
    isValid: matchesWidth && matchesHeight && matchesRatio,
    matchesWidth,
    matchesHeight,
    matchesRatio,
  };
};
